
namespace Gordic.Epk.WebControls
{
    /** parametry nastavení tlačítka vyřízení */
    export interface ISettlementButtonChecked{
        schvalitVyrizeniSpisu: boolean,
        pridelit: boolean,
        predat: boolean,
        podepsat: boolean,
        schvalit: boolean,
        posoudit: boolean,
        vzitnavedomi: boolean,
        /** specialita pro UKR */
        splnit: boolean,
        /** specialita pro UKR */
        rozhodnout: boolean,
        /** podepsat přílohy */
        podepsatPrilohy: boolean
    }

    export interface ISettlementButtonEnabled {
        zamitnout: boolean,
        posoudit: boolean,
        vyridit: boolean 
    }

    export interface ISettlementButtonOpt {
        actions: GActionList,
        /** příznak, že se row.ixs_fun_komu rovná s ixs_fun ze sessionInfo */
        sessionIxsFunFlag: boolean,
        gcontent: GContentType<GEpkDbParamsNew>,
        multi: boolean
    }

    /** 
     *  Třída metod obsluhující tlačítka v menubaru
     */
    export class MenuButtonsService
    {
        /**
         * Jsou všechny stavy vyřízení nenastaveny?
         * @param checked hodnoty
         */
        private isAllSettlementsDontSet(checked: ISettlementButtonChecked) {
            if (checked.schvalitVyrizeniSpisu === true || checked.pridelit === true || checked.predat === true) {
                return false;
            }
            else if (checked.podepsat === true || checked.schvalit === true || checked.posoudit === true || checked.vzitnavedomi === true || checked.splnit === true || checked.rozhodnout === true) {
                return false;
            }
            else {
                return true;
            }
        }

        private jeVynucenoProvest(hodnotaParam) {
            return hodnotaParam === "3"; //CheckBoxSetting.Hidden_Allways
        }

        private attachmentsWillBeSigned(opt: ISettlementButtonOpt, checked: ISettlementButtonChecked): boolean {

            var cnt = opt.gcontent;
            var row = opt.gcontent.row;
            var common = new GEpkCommon();

            if (row == null || row.s_pri == null || row.priz_epk_pocet == null)
                return this.jeVynucenoProvest(cnt.EpkParams.epk_zaskpril) || cnt.EpkParams.epk_zaskpril === "1"; //CheckBoxSetting.Visible_Checked;

            return (checked.podepsat || common.canRequestBeSigned(cnt.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod)) && //zda je vubec povoleno
                (row.s_pri > 0 || row.priz_epk_pocet > 0 || (checked.podepsatPrilohy === true) || (this.jeVynucenoProvest(cnt.EpkParams.epk_zaskpril))); //a zda je nastaveno
        }

        public setButtonsEmptyGrid(_cnt: any, typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk | null) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;

            var options: IMenuButtonsServiceOpt = {
                actVyrizeni: {
                    action: cnt.actions.actVyrizeni,
                    caption: "jres:32000703" //RC 32000703 : Nelze vyřidit
                },
                actVyrizeniContext: {
                    action: cnt.actions.actVyrizeniContext,
                },
                actNastaveniVyrizeni: {
                    action: cnt.actions.actNastaveniVyrizeni,
                },
                actVratit: {
                    action: cnt.actions.actVratit,
                },
                actVratitContext: {
                    action: cnt.actions.actVratitContext,
                },
                actKPosouzeni: {
                    action: cnt.actions.actKPosouzeni,
                },
                actKPosouzeniContext: {
                    action: cnt.actions.actKPosouzeniContext,
                }
            };

            // thazmuka (1.10.2021) - v případě prázdného gridu reset hodnot na políčku v menu
            if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi)
                options.actKPosouzeni.caption = options.actKPosouzeniContext.caption = "jres:32000787"; //RC 32000787 : Dát na vědomí
            else 
                options.actKPosouzeni.caption = options.actKPosouzeniContext.caption = "jres:26265003"; //RC 26265003 : K posouzení

            this.xActions(options, true);
        }

        public setButtons(opt: ISettlementButtonOpt, enabled: ISettlementButtonEnabled, checked: ISettlementButtonChecked)
        {
            var multi = opt.multi;
            var cnt = opt.gcontent;
            var LinkedTemplate = cnt.LinkedTemplate;
            var row = cnt.row;

            //#region -- MENU OPTIONS --

            var options: IMenuButtonsServiceOpt = {
                actVyrizeni: {
                    action: opt.actions.actVyrizeni,
                    caption: "jres:32000703" //RC 32000703 : Nelze vyřidit
                },
                actVyrizeniContext: {
                    action: opt.actions.actVyrizeniContext,
                },
                actNastaveniVyrizeni: {
                    action: opt.actions.actNastaveniVyrizeni,
                },
                actVratit: {
                    action: opt.actions.actVratit,
                },
                actVratitContext: {
                    action: opt.actions.actVratitContext,
                },
                actKPosouzeni: {
                    action: opt.actions.actKPosouzeni,
                },
                actKPosouzeniContext: {
                    action: opt.actions.actKPosouzeniContext,
                }
            };

            //#endregion

            //#region -- jizVyrizen --

            var jizVyrizen = false;

            if (multi !== true) {           // pouze pro jednotlivé vyřízení
                if (row != null && row.ixp != null)
                    jizVyrizen = row.zpus_vyriz !== 0 ? true : false;
            }

            //#endregion

            var vyriditState: Gordic.Wfl.Interface.TypPozadavkuEpk | null = null;
            var caption = "jres:32000064"; //RC 32000064 : Nelze vyřídit
            var tooltip = ""; 

            if (jizVyrizen === true) {
                caption = "jres:32000672"; //RC 32000672 : Nelze vyřídit
                caption += String.Format(" ({0})", "jres:32000673"); //RC 32000673 : již je vyřízeno
                enabled.zamitnout = false;
                return vyriditState;
            }

            enabled.vyridit = !jizVyrizen;  // nastavení tlačítka vyřízení

            if (checked.schvalit === true && checked.podepsat === true) {
                caption = "jres:32000661"; //RC 32000661 : Podepsat a schválit
                if (this.attachmentsWillBeSigned(opt, checked)) {
                    caption += String.Format(" ({0})", "jres:32000662"); //RC 32000662 : včetně příloh
                }
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
            }
            else if (checked.schvalit === true && checked.podepsat === false) {
                if (checked.podepsatPrilohy === true && cnt.EpkParams.epk_povpodppri === true) {
                    caption = "jres:32000663"; //RC 32000663 : Schválit
                    caption += String.Format(" ({0})", "jres:32000664"); //RC 32000664 : podepsat pouze přílohy
                }
                else {
                    caption = "jres:32000663"; //RC 32000663 : Schválit
                }
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Schvalit;
            }
            else if (checked.schvalit === false && checked.podepsat === true) {
                caption = "jres:32000665"; //RC 32000665 : Podepsat
                if (this.attachmentsWillBeSigned(opt, checked)) {
                    caption += String.Format(" ({0})", "jres:32000662"); //RC 32000662 : včetně příloh
                }
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat;
            }
            else if (checked.posoudit === true) {
                caption = "jres:32000666"; //RC 32000666 : Posoudit
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Posoudit;
            }
            else if (checked.vzitnavedomi === true) {
                caption = "jres:32000667"; //RC 32000667 : Vzít na vědomí
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi;
            }
            else if (checked.schvalitVyrizeniSpisu === true) {
                caption = "jres:32000644"; //RC 32000644 : Schválit vyřízení spisu
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu;
            }
            else if (checked.pridelit === true) {
                caption = "jres:32000630"; //RC 32000630 : Schválit přidělení
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni;
            }
            else if (checked.predat === true) {
                caption = "jres:32000631"; //RC 32000631 : Schválit předání
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Predani;
            }
            else if (checked.splnit === true) {
                caption = "jres:32000429"; //RC 32000429 : Splnit
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Splnit;
            }
            else if (checked.rozhodnout === true) {
                caption = "jres:32000454"; //RC 32000454 : ANO
                tooltip = "jres:32000450"; //RC 32000450 : Rozhodnout
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout;
            }
            else if (this.attachmentsWillBeSigned(opt, checked) === true && cnt.EpkParams.epk_povpodppri === true) {
                caption = "jres:32000665"; //RC 32000665 : Podepsat
                if (this.attachmentsWillBeSigned(opt, checked)) {
                    caption += String.Format(" ({0})", "jres:32000668"); //RC 32000668 : pouze přílohy
                }
                vyriditState = Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat;
            }
            else {
                if (row != null && row.zpus_vyriz != null && row.zpus_vyriz > 0) {
                    caption = "jres:32000669"; //RC 32000669 : Nelze vyřídit
                    caption += String.Format(" ({0})", "jres:32000670"); //RC 32000670 : již je vyřízeno
                    enabled.zamitnout = false;
                }
                else {
                    caption = "jres:32000669"; //RC 32000669 : Nelze vyřídit
                    caption += String.Format(" ({0})", "jres:32000671"); //RC 32000671 : způsob není zvolen
                }
                enabled.vyridit = false;
            }


            var enabledZamitnout = opt.sessionIxsFunFlag === false ? false : enabled.zamitnout;
            var enabledVyridit = opt.sessionIxsFunFlag === false ? false : enabled.vyridit;
            var enabledPosoudit = opt.sessionIxsFunFlag === false ? false : enabled.posoudit;

            var priz_spis = row?.priz_spis;
            var typ_pozad_pod = row?.typ_pozad_pod;


            // žádost je zablokovaná k vyřízení (pravděpodobně se vyřizuje) 
            if (row != null && row.vyriz_async != null && row.vyriz_async > 0) {

                caption = "jres:32000675"; //RC 32000675 : Nelze vyřídit
                enabledZamitnout = false;
                enabledVyridit = false;
                enabledPosoudit = false;

            }
            else {

                // thazmuka (30.10.2020)
                // jedná-li se o spis, lze vyřídit pouze posouzením či vzetím na vědomí
                if (priz_spis != null && priz_spis === 1) {
                    var haveIxb = row != null && row?.ixb != null;
                    if ((checked.schvalit === true && checked.podepsat === false)
                        || checked.schvalitVyrizeniSpisu === true
                        || checked.posoudit === true
                        || checked.vzitnavedomi === true
                        || checked.pridelit === true        //thazmuka (17.01.2021) - přidáno přidělení, předání spisu přes EPK, které nebylo obslouženo
                        || checked.predat === true
                    ) {
                        // nastaveno
                        console.log("Spis lze v EPK vyřídit.");
                    }
                    else if (haveIxb === true &&
                        ((checked.podepsat === true && checked.schvalit === false) ||
                            (checked.podepsat === true && checked.schvalit === true))) {
                        // nastaveno
                        console.log("Spis má el. obraz. Spis lze v EPK vyřídit.");
                    }
                    else {
                        caption = "jres:32000675"; //RC 32000675 : Nelze vyřídit
                        enabledZamitnout = false;
                        enabledVyridit = false;
                        enabledPosoudit = false;
                    }
                }

            }

            

            var captionVratitKPrepracovani = "jres:32000040"; //RC 32000040 : Vrátit k přepracování
            if (vyriditState === Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout) {
                captionVratitKPrepracovani = "jres:32000455"; //RC 32000455 : NE
            }

            if (vyriditState === Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout && cnt.LinkedTemplate != null) {
                // povoleno
                if (LinkedTemplate.povoleno != null && LinkedTemplate.povoleno.ssa_nazev != null && LinkedTemplate.povoleno.sro_typ != null && LinkedTemplate.povoleno.ixs_fun_nazev != null) {
                    caption = caption + " | " + LinkedTemplate.povoleno.ssa_nazev + " | " + LinkedTemplate.povoleno.sro_typ + " | " + LinkedTemplate.povoleno.ixs_fun_nazev;
                }
                if (LinkedTemplate.vraceno != null && LinkedTemplate.vraceno.ssa_nazev != null && LinkedTemplate.vraceno.sro_typ != null && LinkedTemplate.vraceno.ixs_fun_nazev != null) {
                    captionVratitKPrepracovani = captionVratitKPrepracovani + " | " + LinkedTemplate.vraceno.ssa_nazev + " | " + LinkedTemplate.vraceno.sro_typ + " | " + LinkedTemplate.vraceno.ixs_fun_nazev;
                }
            }

            var tooltipVratit = "jres:32000364"; //RC 32000364 : Provede zamítnutí požadavku. V závislosti na stavu schvalovacího procesu může dojít k ukončení celého procesu.

            if (vyriditState === Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout)
                tooltipVratit = "";

            if (multi === true) {
                caption = "jres:32000701";                      //RC 32000701 : Hromadné vyřízení
                captionVratitKPrepracovani = "jres:32000702";   //RC 32000702 : Hromadně vrátit k přepracování
            }

            options.actVyrizeni.enabled = enabledVyridit;
            options.actVyrizeni.caption = caption;
            options.actVyrizeni.tooltip = tooltip;

            options.actVyrizeniContext.enabled = enabledVyridit;
            options.actVyrizeniContext.caption = caption;
            options.actVyrizeniContext.tooltip = tooltip;

            options.actNastaveniVyrizeni.enabled = multi === true ? false : enabledVyridit;

            options.actVratit.enabled = enabledZamitnout;
            options.actVratit.caption = captionVratitKPrepracovani;
            options.actVratit.tooltip = tooltipVratit;

            options.actVratitContext.enabled = enabledZamitnout;
            options.actVratitContext.caption = captionVratitKPrepracovani;
            options.actVratitContext.tooltip = tooltip;


            // -- K POSOUZENÍ --

            var captionKPosouzeni = multi === true ?
                "jres:32000758" :   //RC 32000758 : Hromadné předání k posouzení
                "jres:26265003"     //RC 26265003 : K posouzení

            // thazmuka (1.10.2021) - novinka Dát na vědomí
            if (row?.typ_pozad_pod === 50) {
                captionKPosouzeni = "jres:32000787"     //RC 32000787 : Dát na vědomí
            }

            options.actKPosouzeni.enabled = enabledPosoudit;
            options.actKPosouzeni.caption = captionKPosouzeni;

            options.actKPosouzeniContext.enabled = enabledPosoudit;
            options.actKPosouzeniContext.caption = captionKPosouzeni;

            // pokud se jedná o dání na vědomí - a zároveň je multi vyřízení
            if (row?.typ_pozad_pod === 50 && multi === true) {
                options.actKPosouzeni.enabled = options.actKPosouzeniContext.enabled = false;
            }

            this.xActions(options);
            return vyriditState;
        }

        updateMenuActions(opt: IMenuButtonsServiceAction[]) {
            for (var index = 0; index < opt.length; index++) {
                var item = opt[index];
                if (item.action != null) {
                    item.action.update({
                        enabled: item.enabled,
                        tooltip: item.tooltip,
                        caption: item.caption
                    });
                }
            }
        }

        xActions(opt: IMenuButtonsServiceOpt, disableAll?: true) {
            for (var item in opt) {
                var value: IMenuButtonsServiceAction = opt[item];
                if (value.action != null) {
                    value.action.update({
                        enabled: disableAll === true ? !disableAll : value.enabled,
                        tooltip: value.tooltip,
                        caption: value.caption
                    });
                }
            }
        }

    }

    interface IMenuButtonsServiceOpt {
        actVyrizeni: IMenuButtonsServiceAction,
        actVyrizeniContext: IMenuButtonsServiceAction,
        actNastaveniVyrizeni: IMenuButtonsServiceAction,
        actVratit: IMenuButtonsServiceAction,
        actVratitContext: IMenuButtonsServiceAction,
        actKPosouzeni: IMenuButtonsServiceAction,
        actKPosouzeniContext: IMenuButtonsServiceAction,
    }

    interface IMenuButtonsServiceAction {
        /** akce tlačítka */
        action?: GAction | null,
        /** povolení tlačítka */
        enabled?: boolean,
        /** popisek */
        caption?: string,
        /** nápověda */
        tooltip?: string
    }
    
}
